export default "__VITE_ASSET__x$05h1T0__"